import {createStore} from 'redux'

import storeEnhancer from "./enhancers";
import root from './reducers';

export default function(preloadedState) {
    const store = createStore(
        root.reducer,
        root.state,
        storeEnhancer()
    );
    return store;
};